
import Vue from 'vue'
import { authAxios } from '../utils'
import { Component } from 'vue-property-decorator'
import CodeInput from '../../global/components/CodeInput.vue'

@Component({
  components: { CodeInput }
})
export default class TwoFactorLogin extends Vue {
  error: string | null = null

  isLoading = false

  get codeInput() {
    return this.$refs.field as CodeInput
  }

  async back() {
    await authAxios.get('/logout')
    this.$store.commit('auth/logout')
    this.$emit('back')
  }
  async onComplete(code: string) {
    this.isLoading = true
    this.error = null
    try {
      await authAxios.post('/mfa', { token: code })
      this.$store.dispatch('success', 'Authenticated successfully')
      this.$emit('success')
    } catch (err) {
      if (err.response && err.response.data && ['ACCOUNT_LOCKED', 'TOO_MANY_REQUESTS'].includes(err.response.data.code)) {
        this.error = err.response.data.message
      } else {
        this.error = 'Submission failed. Please double-check your code and try again.'
      }
      this.codeInput.reset()
    } finally {
      this.isLoading = false
    }
  }
}
